import * as yup from 'yup';

export const validateUnique = (values, name, error) => {
  return yup.string().test(name, error, (v) => {
    const seen = {};

    for (let i = 0; i < values.length; i++) {
      const element = values[i][name];

      if (seen[element] && element === v.toString()) {
        return false;
      }

      seen[element] = true;
    }

    return true;
  })
};
